import { Box, Button, Grid, Paper, Typography } from "@material-ui/core";
import { useState } from "react";


import { toast } from "react-toastify";
import { useFetchContext } from "../../../../common/FetchContext";
import { useSaveEdgePinchResults } from "../../../projectManagementMutations";

export const EdgeFinalSubmitStage = ({
  tableData,
  onBack,
  asset,
  showdata,
   onSuccess,
}: any) => {
  const {authAxios} = useFetchContext();

  const { mutateAsync: mutateEdgePinch } = useSaveEdgePinchResults();

  const [saving, setSaving] = useState(false);

  const modules = tableData
    ?.map((item: any) => item.serial_number)
    .join(", ");

  const handleSubmit = async () => {
    try {
      setSaving(true);

      const payload = {
        asset_id: asset,
        data: tableData
      };
      await mutateEdgePinch({
        authAxios,
        ...payload,
      });


      console.log("payload:", payload);
      toast.success("Edge Pinch Measurements submitted successfully!");
      // API CALL
      onSuccess?.();

    } catch(error){
      toast.error("Error submitting measurements. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Typography variant="h6">
        Submit Measurements
      </Typography>
      <Box mt={2}>
        <Paper elevation={2} style={{ padding: 16 }}>
          <Typography variant="h6" gutterBottom>
            Project Details
          </Typography>

          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Typography>
                <strong>Project Number:</strong>
              </Typography>
              <Typography color="textSecondary">
                {showdata.project_number}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography>
                <strong>Customer Name:</strong>
              </Typography>
              <Typography color="textSecondary">
                {showdata.customer_name}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography>
                <strong>BOM:</strong>
              </Typography>
              <Typography color="textSecondary">
                {showdata.bom}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography>
                <strong>Modules:</strong>
              </Typography>
              <Typography color="textSecondary">
                {modules}
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Box>

      <Box mt={3} display="flex" justifyContent="space-between">



        <Button
          variant="outlined"
          onClick={onBack}
        >
          Back
        </Button>

        <Button
          variant="contained"
          color="secondary"
          onClick={handleSubmit}
          disabled={saving}
        >
          {saving ? "Submitting..." : "Submit Measurements"}
        </Button>

      </Box>
    </>
  );
};